import { EMPLOYMENT_STATUSES } from "shared/config/constants/app.constants";

import { toDate } from "../utils";

import {
  Employment,
  IncomeAssetsSummaryResponse,
  VerificationTypes,
} from "./interfaces";

export const mapEmployment = (
  employmentStatus: string,
  employment?: Record<string, any>[],
  linkedEmployment?: boolean,
  isArgyleEnabled?: boolean,
  incomeAsset?: IncomeAssetsSummaryResponse
): Employment => {
  // always return employment
  const active = employment?.filter(
    (history) => history.isPreviousEmployment === false
  );
  if (active?.length) employment = active;
  const em = employment?.sort((a, b) =>
    !a.endDate || a.endDate > b.endDate ? -1 : 1
  )?.[0];
  const annualSalary = em?.annualSalary ?? em?.annualSalary;

  let verificationTypes: VerificationTypes[] = [];
  // Only add LINK_BANK_ACCOUNT if:
  // 1. Bank account is linked (assetsStatus is Complete/Confirmed) AND
  // 2. There are actual active income streams from that account
  // This prevents showing "Linked Bank Account" when account is linked but no income streams are detected
  if (
    incomeAsset &&
    (incomeAsset.assetsStatus === 2 || incomeAsset.assetsStatus === 3) &&
    (incomeAsset.numberOfActiveIncomeStreams ?? 0) > 0
  )
    verificationTypes.push(VerificationTypes.LINK_BANK_ACCOUNT);
  if (em?.isLinkedAutomatically)
    verificationTypes.push(VerificationTypes.LINKED_EMPLOYMENT);
  else if (em?.fromFormUpload)
    verificationTypes.push(VerificationTypes.DOCUMENT_UPLOADED);
  else if (
    employmentStatus === EMPLOYMENT_STATUSES.employed &&
    !em?.isLinkedAutomatically &&
    !em?.fromFormUpload &&
    !verificationTypes.find(
      (type) => type === VerificationTypes.LINK_BANK_ACCOUNT
    )
  )
    verificationTypes.push(VerificationTypes.MANUAL_UPLOAD);
  if (
    employmentStatus === EMPLOYMENT_STATUSES.unemployed ||
    employmentStatus === EMPLOYMENT_STATUSES.nonUsEmployedOrBankAccounts ||
    employmentStatus === EMPLOYMENT_STATUSES.guarantorIncome ||
    employmentStatus === EMPLOYMENT_STATUSES.other
  ) {
    verificationTypes = [VerificationTypes.UNEMPLOYED];
    return {
      skipped: false,
      employed: false,
      enabled: isArgyleEnabled,
      verificationTypes,
    };
  }

  const isEmployed = !em
    ? undefined
    : !em.endDate || new Date(em.endDate) > new Date();

  return {
    skipped: !linkedEmployment,
    jobTitle: em?.jobTitle ?? undefined,
    employed: isEmployed,
    company: em?.employerName,
    start: toDate(em?.startDate),
    end: toDate(em?.endDate),
    annualSalary,
    monthlySalary: annualSalary >= 0 ? annualSalary / 12 : undefined,
    enabled: isArgyleEnabled,
    verificationTypes,
  };
};
